// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Iwtj","textarea":"styles_textarea__2DL4E"};